<template>
  <div class="win">
    <h1>{{$t('integration.realTime_status_detectio_device')}} -- {{ realTime }}</h1>
    <i class="el-icon-refresh icon" @click="handleRefresh"></i>
    <!-- 右侧设备信息框 -->
    <el-empty
      v-if="newArray.length === 0"
      :description="$t('integration.no_data_temporarily')"
    ></el-empty>
    <div v-else class="rightMsg">
      <Msg
        v-for="item in newArray"
        :key="item.id"
        :infoObj="item"
        :iconDetaiArray="changeIcon(item)"
      >
        <!-- 传感器关联网关 -->
        <template v-slot:sensor-w v-if="item.deviceCatalog == 0">
          <li :title="$t('integration.gateway')">
            <span>{{ item.param.gatewayName }}</span>
            <i
              class="el-icon-tickets"
              :title="$t('integration.gateway_details')"
              @click="handleGateway(item)"
            ></i>
          </li>
        </template>
        <!-- 网关的mac -->
        <template v-slot:gateway-mac v-if="item.deviceCatalog == 1">
          <li :title="$t('integration.mac_address')">
            <span>{{ item.param.mac }}</span>
          </li>
        </template>
        <!-- 显示屏的时区 -->
        <template v-slot:dispaly-timeZone v-if="item.deviceCatalog == 2">
          <li :title="$t('integration.time_zone')">
            <span>{{ timeCode(item.param.timeCode) }}</span>
          </li>
        </template>
      </Msg>
    </div>
    <sensorDetailDialog :show.sync="sensorDetailShow"></sensorDetailDialog>
    <gatewayDetailDialog :show.sync="gatewayDetailShow"></gatewayDetailDialog>
    <displayDetailDialog :show.sync="displayDetailShow"></displayDetailDialog>
    <relayDetailDialog :show.sync="relayDetailShow"></relayDetailDialog>
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog.vue'
import { monitorGetDeviceList } from '@/api/modules/dataBoard.js'
import { shareParam } from '@/api/modules/public.js'
import {
  displayscreenTypeConvert,
  equiStatusConvert,
  gatewayTypeConvert,
  relayTypeConvert
} from '@/utils/convert'
import Msg from '../rightMsg/Msg.vue'
import gatewayDialog from '@/pages/equipment/gateway/components/DetailDialog.vue'
import { ENUM_RE_DEVICE_TYPE } from '@/common/enum/reverse/device'
import { multiCarrierFormat } from '@/utils/multiCarrier'
import { ENUM_DEVICE_TYPE } from '@/common/enum/forward/device'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  components: {
    Msg,
    gatewayDialog,
    sensorDetailDialog,
    gatewayDetailDialog,
    displayDetailDialog,
    relayDetailDialog
  },
  data () {
    return {
      // 详情
      sensorDetailShow: false,
      gatewayDetailShow: false,
      displayDetailShow: false,
      relayDetailShow: false,
      sensorTypeConvert,
      equiStatusConvert,
      displayscreenTypeConvert,
      relayTypeConvert,
      newArray: [],
      realTime: null,
      timer: null,
      timeCodeArray: [],
      iconDetaiArray: [],
      // 网关详情
      isDetailShow: false,
      detailTitle: '',
      detailObj: {},
      deviceType: {},
      deviceProperty: {},
      netObj: {}
    }
  },
  created () {
    this.getRealTime()
    this.getTimeCodeFn()
    // const newArray = sessionStorage.getItem('newArray')
    // this.newArray = JSON.parse(newArray)
    this.handleRefresh()
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    getTimeCodeFn () {
      shareParam({
        code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE',
        type: 0
      }).then(({ result }) => {
        this.timeCodeArray = result
      })
    },
    timeCode (code) {
      let str
      for (const item of this.timeCodeArray) {
        if (item.code === code) {
          str = item.name
          break
        }
      }
      return str
    },
    getRealTime () {
      this.realTime = this.$timetransition(new Date().getTime())
      this.timer = setInterval(() => {
        this.realTime = this.$timetransition(new Date().getTime())
      }, 1000)
    },
    changeIcon (item) {
      const array = [
        {
          id: 4,
          icon: 'el-icon-tickets',
          title: $t('integration.equipment_details')
        }
      ]
      switch (String(item.deviceCatalog)) {
        case '0': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: sensorTypeConvert(item.param.type).icon,
              title: this.$t(sensorTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'el-icon-data-line',
              title: $t('integration.historical_line_chart')
            }
          ].concat(array))
        }
        case '1': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: gatewayTypeConvert(item.param.type).icon,
              title: this.$t(gatewayTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'iconfont icon-xintiao',
              title: $t('integration.whether_to_start_heartbeat')
            }
          ].concat(array))
        }
        case '2': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: displayscreenTypeConvert(item.param.type).icon,
              title: this.$t(displayscreenTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'iconfont icon-guanbibaojing',
              title: $t('device.alarm_on')
            }
          ].concat(array))
        }
        case '3': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: relayTypeConvert(item.param.type).icon,
              title: this.$t(relayTypeConvert(item.param.type).title)
            }
          ].concat(array))
        }
        default:
          break
      }
    },
    handleRefresh () {
      monitorGetDeviceList(Object.keys(this.$route.query).length > 0 ? this.$route.query : null).then(({ result }) => {
        result = result.map(item => {
          const code = ENUM_RE_DEVICE_TYPE[item.deviceCatalog].code
          return {
            deviceCatalog: item.deviceCatalog,
            param:
              item.deviceCatalog === ENUM_DEVICE_TYPE.DISPLAY ||
              ENUM_DEVICE_TYPE.GATEWAY
                ? this.disFn(item[code])
                : item[code]
          }
        })
        this.newArray = result
      })
    },
    // 网关详细
    handleGateway (item) {
      bus.$emit('gatewayParam', item.param.gatewayId, item.param.gatewayName)
    },
    disFn (item) {
      const dataInfo = {}
      ;(item.carrierRspList || []).forEach((item, index) => {
        const { structureId, sceneName, fullPath } = item
        if (!dataInfo[structureId]) {
          dataInfo[structureId] = {
            sceneName,
            structureId,
            fullPath,
            child: []
          }
        }
        dataInfo[structureId].child.push(item)
      })
      const list = Object.values(dataInfo) // list 转换成功的数据
      item.carrierList = { ...item.carrierRspList }
      item.carrierRspList = list
      return multiCarrierFormat(item)
    }
  }
}
</script>

<style lang="scss" scoped>
.win {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;

  h1 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }

  .icon {
    position: absolute;
    top: 15px;
    right: 10px;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: red;
    }
  }
}

.rightMsg {
  width: 100%;
  height: calc(100% - 32px);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: auto;
}
</style>
